import { Form } from 'antd';
import { Button, Colors, IcPlus, InputSearch, Row, Select, Text } from 'basic-ui-lib';
import { useCallback, useMemo, useState } from 'react';
import styled from 'styled-components';
import useDebounce from 'hooks/useDebounce';
import useGetAllStores from 'modules/dashboard/services/hooks/useGetAllStore';
import useGetListPlaylists from 'modules/playlist/services/hooks/useGetListPlaylists';
import NewPlaylistModal from '../NewPlaylistModal';
import { useMediaQuery } from 'react-responsive';

const PlaylistFilter = () => {
  const [form] = Form.useForm();
  const [, , mutate] = useGetListPlaylists(true);
  const { stores } = useGetAllStores(true);
  const [open, setOpen] = useState(false);
    const isMobile = useMediaQuery({ maxWidth: 768 });

  const onSearchDebounce = useCallback((value: string) => {
    mutate({ page: 1, size: 10, keySearch: value });
  }, []);

  const { text: searchText, setText: setSearchText } = useDebounce({
    timeDebounce: 600,
    onDebounce: onSearchDebounce,
  });

  const handleCreateNewPlaylist = () => {
    // navigate('/playlist/create');
    setOpen(true);
  };

  const storeOptions = useMemo(() => {
    return [
      { label: 'All Stores', value: '' },
      ...stores.map((store) => ({
        label: store.storeName,
        value: store.storeId,
      })),
    ];
  }, [stores]);

  const onFinish = (values: { keySearch: string; storeId: string }) => {
    mutate({
      page: 1,
      size: 10,
      keySearch: values.keySearch || '',
      storeId: values.storeId || '',
    });
  };
  return (
    <Container>
      <Form form={form} layout='vertical' className='form-container' onFinish={onFinish}>
        <Row width='45%'>
          <Text title_h2 semibold>
            Playlists
          </Text>
        </Row>
        <Row gap={16} width='60%' justifyContent='flex-end' className='search-mobile'>
          <Form.Item name='keySearch' noStyle>
            <InputSearch
              placeholder='Search playlist name'
              value={searchText}
              onChange={(value) => setSearchText(value)}
            />
          </Form.Item>
          {isMobile ? null : (
            <>
              <Form.Item name='storeId' noStyle>
                <Select options={storeOptions} onChange={() => form.submit()} placeholder='Select Store'/>
              </Form.Item>
              <Button
                type_second
                lg
                type='button'
                prefix={<IcPlus fill={Colors.neutral.bg[1]} width={20} height={20} />}
                onClick={handleCreateNewPlaylist}
              >
                New Playlist
              </Button>
            </>
          )}
        </Row>
      </Form>
      <NewPlaylistModal isOpen={open} onClose={() => setOpen(false)} />
    </Container>
  );
};

export default PlaylistFilter;

const Container = styled.div`
  width: 100%;

  .form-container {
    width: 100%;
    display: flex;
    align-items: center;
  }

  .custom-text {
    white-space: nowrap;
  }

  .ant-select {
    min-width: 180px;
  }

  @media (max-width: 768px) {
    .form-container {
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;

      .title_h2 {
        font-size: 24px;
      }

      .search-mobile {
        width: 100%!important;
      }
    }
  }
`;
